module.exports = __webpack_public_path__ + "static/media/BankDetailCheck.d16c6a29.svg";